import { UNLIMITED } from "../constants/unlimited";
import i18n from "../lib/i18n";

const formatCurrency = (amount, options = {}) => {
  const {
    asString,
    currencySymbolInFront,
    decimalSeparator,
    decimalZerosReplacement,
    replaceZeros,
    unicodeCurrencySymbol
  } = options;
  const scale = 2;
  let formattedAmount = amount;
  let trialAmount = "";

  formattedAmount = formattedAmount.toFixed(scale);
  formattedAmount = formattedAmount.toString();

  let splitAmount = formattedAmount.split(".");

  let mainAmount = splitAmount[0];
  if (replaceZeros && splitAmount[1].indexOf("00") >= 0) {
    trialAmount = splitAmount[1].replace("00", decimalZerosReplacement);
  } else {
    trialAmount = `${decimalSeparator}${splitAmount[1]}`;
  }

  if (asString) {
    if (currencySymbolInFront) {
      return `${unicodeCurrencySymbol} ${mainAmount}${trialAmount}`;
    } else {
      return `${mainAmount}${trialAmount} ${unicodeCurrencySymbol}`;
    }
  } else {
    return {
      currencySymbolInFront: currencySymbolInFront,
      mainAmount: mainAmount,
      trialAmount: trialAmount,
      unit: unicodeCurrencySymbol
    };
  }
};

const formatDataCredits = (amount, options = {}) => {
  const { asString, decimalSeparator, showShort } = options;
  let formattedAmount = "";
  let formattedUnit = "";

  if (amount === UNLIMITED) {
    if (showShort) {
      formattedAmount = i18n.t("dataCredits:unlimitedShort");
    } else {
      formattedAmount = i18n.t("dataCredits:unlimited");
    }
  } else {
    if (amount < 1000) {
      formattedAmount = amount.toString();
      formattedUnit = i18n.t("dataCredits:mb");
    } else {
      let newAmount = amount / 1000;
      newAmount = Math.round(newAmount * 10) / 10;
      newAmount = newAmount.toString().replace(".", decimalSeparator);
      formattedAmount = newAmount;
      formattedUnit = i18n.t("dataCredits:gb");
    }
  }

  if (asString) {
    return `${formattedAmount} ${formattedUnit}`;
  } else {
    return {
      amount: formattedAmount,
      unit: formattedUnit
    };
  }
};

const formatDataSpeed = (amount, options = {}) => {
  const { asString, decimalSeparator } = options;
  let formattedAmount = "";
  let formattedUnit = "";

  if (amount < 1000) {
    formattedAmount = amount.toString();
    formattedUnit = i18n.t("dataSpeed:mbits");
  } else {
    let newAmount = amount / 1000;
    newAmount = Math.round(newAmount * 10) / 10;
    newAmount = newAmount.toString().replace(".", decimalSeparator);
    formattedAmount = newAmount;
    formattedUnit = i18n.t("dataSpeed:gbits");
  }

  if (asString) {
    return `${formattedAmount} ${formattedUnit}`;
  } else {
    return {
      amount: formattedAmount,
      unit: formattedUnit
    };
  }
};

const formatSmsCredits = (amount, options = {}) => {
  const { asString, showShort } = options;
  let formattedAmount = "";
  let formattedUnit = "";

  if (amount === UNLIMITED) {
    if (showShort) {
      formattedAmount = i18n.t("smsCredits:unlimitedShort");
      formattedUnit = i18n.t("smsCredits:sms");
    } else {
      formattedAmount = i18n.t("smsCredits:unlimited");
      formattedUnit = i18n.t("smsCredits:sms");
    }
  } else {
    formattedAmount = amount.toString();
    formattedUnit = i18n.t("smsCredits:sms");
  }

  if (asString) {
    return `${formattedAmount} ${formattedUnit}`;
  } else {
    return {
      amount: formattedAmount,
      unit: formattedUnit
    };
  }
};

const formatVoiceCredits = (amount, options = {}) => {
  const {
    asString,
    decimalSeparator,
    voiceCreditsInHours,
    showShort,
    withUnit
  } = options;
  let formattedAmount = "";
  let formattedUnit = "";

  if (amount === UNLIMITED) {
    if (showShort) {
      formattedAmount = i18n.t("voiceCredits:unlimitedShort");
    } else {
      formattedAmount = i18n.t("voiceCredits:unlimited");
    }
  }

  if (voiceCreditsInHours) {
    if (amount < 60) {
      if (withUnit) {
        formattedAmount = amount.toString();
        formattedUnit = i18n.t("voiceCredits:minutes");
      } else {
        formattedAmount = amount.toString();
      }
    } else if (amount < UNLIMITED) {
      let newAmount = amount / 60;
      newAmount = Math.round(newAmount * 10) / 10;
      newAmount = newAmount.toString().replace(".", decimalSeparator);
      if (withUnit) {
        formattedAmount = newAmount;
        formattedUnit = i18n.t("voiceCredits:hours");
      } else {
        formattedAmount = newAmount;
      }
    } else {
      if (withUnit) {
        formattedUnit = i18n.t("voiceCredits:hours");
      }
    }
  } else if (amount < UNLIMITED) {
    if (withUnit) {
      formattedAmount = amount.toString();
      formattedUnit = i18n.t("voiceCredits:minutes");
    } else {
      formattedAmount = amount.toString();
    }
  } else {
    if (withUnit) {
      formattedUnit = i18n.t("voiceCredits:minutes");
    }
  }

  if (asString) {
    return `${formattedAmount} ${formattedUnit}`;
  } else {
    return {
      amount: formattedAmount,
      unit: formattedUnit
    };
  }
};

export {
  formatCurrency,
  formatDataCredits,
  formatDataSpeed,
  formatSmsCredits,
  formatVoiceCredits
};
